module.exports = __webpack_public_path__ + "img/special_offer2.bb83f6a2.png";